import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from 'src/environments/environment';

export type AttorneyItem = {
  id: number;
  email: string;
  name: string;
};

type ListAttorneysParams = {
  name?: string;
};

type ListAttorneysResponse = {
  attorneys: AttorneyItem[];
};

@Injectable({
  providedIn: 'root'
})
export class AttorneyService {
  async listAttorneys(params: ListAttorneysParams): Promise<AttorneyItem[]> {
    const result = await axios.get<ListAttorneysResponse>(`${environment.baseUrl}/api/attorney`, { params });
    return result.data.attorneys;
  }
}
